import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DropshippedCategoryAssignmentProductTableItem from './DropshippedCategoryAssignmentProductTableItem';
import {
  IProductQueryData,
  IProductVars,
  useProductQuery,
} from '../../../../../graphql/query/product/useProductQuery';
import GraphQLTable from '../../../../components/_table/GraphQLTable';
import Helmet from '../../../../components/Helmet';
import { IProductSchema } from '../../../../../graphql/type/product';
import ProductLayout from '../../../../layout/Product';
import Context from '../../../../context';
import ButtonBatch from '../../../../components/_button/ButtonBatch';
import FormProductBatchUpdateKeyword from '../../_module/FormProductBatchUpdateKeyword/formProductBatchUpdateKeyword';

function DropshippedCategoryAssignmentProductTable() {
  const { t } = useTranslation();
  const { company } = useContext(Context);
  const [tableRefreshKey, setTableRefreshKey] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<IProductSchema[]>([]);
  const [isOpenBatchDialog, setIsOpenBatchDialog] = useState(false);
  return (
    <>
      <Helmet
        title={`${t('category_assignment', { count: 2 })} | ${t('product')}`}
      />
      <Dialog
        open={isOpenBatchDialog}
        onClose={() => setIsOpenBatchDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <FormProductBatchUpdateKeyword
          onCancel={() => setIsOpenBatchDialog(false)}
          productIds={selectedItems.map((item) => item._id)}
          onSubmit={() => {
            setIsOpenBatchDialog(false);
            setTableRefreshKey(new Date().getTime());
          }}
        />
      </Dialog>
      <GraphQLTable<IProductQueryData, IProductSchema, IProductVars>
        refreshKey={tableRefreshKey}
        select={`
				_id
				ordering
				company
				companyData {
				    _id
					origin
					slug
					aka {
                        la
                        text
                    }
					name {
                        la
                        text
                    }
				}
				sourceDropshippedProductCompanyID
				sourceDropshippedProductCompanyData {
				    _id
					origin
					slug
					aka {
                        la
                        text
                    }
					name {
                        la
                        text
                    }
				}
				keywords {
                  classifications
                  classificationsData {
                    _id
                    name
                  }
                  brands
                  brandsData {
                    _id
                    name
                  }
                  tags
                  tagsData {
                    _id
                    name
                  }
                }
				name {
					la
					text
				}
				slug
				status 
				featured 
				media {
					images {
						status 
						filename
						filename_small
		
						filenameUrl
						filenameSmallUrl
					}
				}
				dropshipping {
				  enable
				}
				updated {
					time 
				}
				created {
					time 
				}
       	 `}
        useQuery={useProductQuery}
        renderHeader={[
          {
            field: '_id',
            label: t('id'),
            align: 'left',
            sortable: true,
          },
          {
            field: 'name',
            label: t('name'),
            align: 'center',
          },
          {
            field: 'company',
            label: t('company'),
            align: 'center',
          },
          {
            field: 'image',
            label: t('image'),
            align: 'center',
          },
          {
            field: 'classifications',
            label: t('classification', { count: 2 }),
            align: 'center',
          },
          {
            field: 'brands',
            label: t('brand', { count: 2 }),
            align: 'center',
          },
          {
            field: 'tags',
            label: t('tag', { count: 2 }),
            align: 'center',
          },
        ]}
        renderItem={(item) => (
          <DropshippedCategoryAssignmentProductTableItem
            item={item}
            setTableRefreshKey={setTableRefreshKey}
          />
        )}
        useCheckbox
        onItemSelected={setSelectedItems}
        selectedItems={selectedItems}
        defaultFilterOptions={{
          companyId: company._id,
          isDropshippedProduct: true,
        }}
        searchFields={{
          _id: { label: t('id') },
          name: { label: t('name') },
        }}
        title={t('category_assignment')}
        defaultSort="createdTime"
        defaultSortOrder={-1}
        itemKey="_id"
        actionButtons={[
          <ButtonBatch
            key="batch"
            color="primary"
            variant="contained"
            size="small"
            text={`${t('batch')} ${t('update')} ${t('keyword')}`}
            onClick={() => setIsOpenBatchDialog(true)}
          />,
        ]}
      />
    </>
  );
}

export default () => (
  <ProductLayout main={<DropshippedCategoryAssignmentProductTable />} />
);
